var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ma-accordion",
    { staticClass: "piece", attrs: { expanded: _vm.expanded } },
    [
      _c("template", { slot: "accordionTop" }, [
        _c("p", { staticClass: "piece-title" }, [
          _vm._v(_vm._s(_vm.pieceTitle)),
        ]),
      ]),
      _c(
        "template",
        { slot: "accordionBottom" },
        [
          !_vm.photosTaken
            ? _c(
                "div",
                { staticClass: "container-input" },
                [
                  _c("ma-input-surface", {
                    staticClass: "input-surface",
                    attrs: {
                      type: "number",
                      name: "surfaceInput",
                      col: "4",
                      literal: _vm.$t("multidamageList.inputTitle"),
                      inputError: _vm.$v.inputSurfaceValue.$error,
                    },
                    on: {
                      change: _vm.handleOnChangeSurfaceInput,
                      input: _vm.handleOnChangeSurfaceInput,
                    },
                    model: {
                      value: _vm.$v.inputSurfaceValue.$model,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.$v.inputSurfaceValue,
                          "$model",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "$v.inputSurfaceValue.$model",
                    },
                  }),
                  !_vm.$v.inputSurfaceValue.$error
                    ? _c(
                        "div",
                        { staticClass: "content-info" },
                        [
                          _c("svgicon", {
                            attrs: {
                              name: "ico-info",
                              color: "#A7AEB6",
                              width: "12",
                              height: "12",
                            },
                          }),
                          _c("p", { staticClass: "info-text grey" }, [
                            _vm._v(_vm._s(_vm.$t("multidamageList.inputHint"))),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "container-photoclaim-gallery" },
            [
              _vm.surfaceInputIsValid && _vm.isPhotoclaimFlow
                ? _c("ma-photoclaim-gallery", {
                    attrs: {
                      photosTaken: _vm.photosTaken,
                      damagedParts: _vm.damagedPiece.photoclaimDamagedParts,
                      spacePhotos: _vm.damagedPiece.spacePhotos,
                    },
                    on: {
                      openPhotoclaimModal: function ($event) {
                        return _vm.$emit(
                          "openPhotoclaimModal",
                          _vm.damagedPiece.damagedParts
                        )
                      },
                      confirmPhotoclaimDamages: function ($event) {
                        return _vm.handleOnPhotoclaimDamagesConfirmed(
                          _vm.damagedPiece,
                          $event
                        )
                      },
                      "add:photoclaimDamage": function ($event) {
                        return _vm.$emit("add:photoclaimDamage", {
                          damagedPiece: _vm.damagedPiece,
                          damagedKey: _vm.damagedKey,
                          damagePart: $event,
                        })
                      },
                      "edit:photoclaimDamage": function ($event) {
                        return _vm.handleOnPhotoclaimDamagesEdit(
                          _vm.damagedPiece,
                          _vm.damagedKey,
                          ...arguments
                        )
                      },
                      "delete:photoclaimDamage": function ($event) {
                        return _vm.handleOnPhotoclaimDamagesDelete(
                          _vm.damagedPiece,
                          _vm.damagedKey,
                          ...arguments
                        )
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._l(_vm.damagedPiece.damagedParts, function (damagedPart) {
            return !_vm.isPhotoclaimFlow
              ? _c(
                  "div",
                  { key: damagedPart.key, staticClass: "content-material" },
                  [
                    _vm.surfaceInputIsValid || _vm.hasDamages
                      ? _c("ma-damaged-part", {
                          attrs: {
                            damagedPart: damagedPart,
                            buttonEnable: _vm.surfaceInputIsValid,
                          },
                          on: {
                            deleteDamagedPart: function ($event) {
                              return _vm.$emit(
                                "deleteDamagedPart",
                                damagedPart.key
                              )
                            },
                            openModal: function ($event) {
                              return _vm.$emit("openModal", $event)
                            },
                            deleteDamage: function ($event) {
                              return _vm.$emit("deleteDamage", {
                                partKey: damagedPart.key,
                                damageIndex: $event,
                              })
                            },
                            editDamage: function ($event) {
                              return _vm.$emit("editDamage", {
                                partKey: damagedPart.key,
                                damageIndex: $event,
                              })
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e()
          }),
          !_vm.surfaceInputIsValid && !_vm.hasDamages
            ? _c("div", { staticClass: "content-material mg mg--t-8 center" }, [
                _c("p", { staticClass: "text-large gray" }, [
                  _vm._v(
                    _vm._s(_vm.$t("multidamageList.calculateSurfaceLink.text1"))
                  ),
                ]),
                _c("p", { staticClass: "text-large gray mg mg--b-2" }, [
                  _vm._v(
                    _vm._s(_vm.$t("multidamageList.calculateSurfaceLink.text2"))
                  ),
                ]),
                _c(
                  "p",
                  {
                    staticClass: "text-link",
                    on: {
                      click: function ($event) {
                        return _vm.$emit("openSurfaceModal")
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "blueDark" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("multidamageList.calculateSurfaceLink.link")
                        )
                      ),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }